module.exports = __webpack_public_path__ + "img/climber.949d34cf.png";